// extracted by mini-css-extract-plugin
module.exports = {"container":"horizontal_card_content-module_container_35eef"};